import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {CandidateDataService} from '../candidate-data.service';
import {User} from '../../../../shared/models/user.model';
import {SelectFieldsTable} from '../../../../shared/select-fields.table';
import {UserLanguages} from '../../../../shared/models/userLanguages.model';
import {UserStudies} from '../../../../shared/models/userStudies.model';
import {UserCareer} from '../../../../shared/models/userCareer.model';
import {UserSkills} from '../../../../shared/models/userSkills.model';
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {UserCertification} from '../../../../shared/models/userCertificationDTO.model';
import {ActivatedRoute, Router} from '@angular/router';
import {Options} from 'select2';
import {Select2OptionData} from "ng-select2";
import {Observable} from "rxjs";
import {HttpEventType, HttpResponse} from "@angular/common/http";
import {UploadFilesService} from "../upload-file.service";
import {UploadService} from "../../../../shared/upload.service";
import {SelectLocationTable} from '../../../../../shared/location-select.table';


@Component({
    selector: 'app-edit-profile',
    templateUrl: './candidate-edit-profile.component.html',
    styleUrls: ['./candidate-edit-profile.component.scss'],
    providers: [SelectFieldsTable, SelectLocationTable]
})

export class CandidateEditProfileComponent implements OnInit {

    profileImageId: string;

    formResponse: boolean;
    formSent: boolean;

    // domains: { name: string, subdomains: Array<string> }[];
    domainsArrayValues: Array<any>;
    subDomainsArrayValues: Array<any> = [];
    departments: Array<string> = [];
    languages: Array<string>;
    // selectedCity: null;
    // selectedCountry: null;
    userDTO: any = [];
    bdVolunteer: any = [];
    fullDataLoaded = false;
    userNewData: any;
    fileUpload: boolean = false;

    selectedDomain: string;
    selectedSubDomain: string;

    // domainsArray:Array<any> =[];

    selectedFiles?: FileList;
    currentFile?: File;
    progress = 0;
    message = '';

    profilePicturePath: string;

    userInfo: any;


    selectFile(event: any): void {
        this.selectedFiles = event.target.files;
    }

    selectedCertification: any;
    toDeleteCertification: any;

    selectedAward: any;
    selectedTop: any;
    selectedTestim: any;
    selectedVolunteer: any;
    selectedSocial: any;
    selectedHobby: any;

    selectedCertifArray = [];
    selectedAwardArray = [];
    selectedTopArray = [];
    selectedTestimArray = [];
    selectedVolunteerArray = [];
    selectedSocialArray = [];
    selectedHobbyArray = [];

    currentDate = new Date();
    underAge : boolean = false;


    trackByFunction(index, item) {
        return item.index;
    }

    selectCertification(e, title: string) {
        this.selectedCertification = {file:e.target.files, title:title};
        this.selectedCertifArray.push(this.selectedCertification);
    }

    selectAwards(e, title: string) {
        this.selectedAward = {file:e.target.files, title:title};
        this.selectedAwardArray.push(this.selectedAward);
    }

    selectTops(e, title: string) {
        this.selectedTop = {file:e.target.files, title:title};
        this.selectedTopArray.push(this.selectedTop);
    }

    selectTestim(e, title: string) {
        this.selectedTestim = {file:e.target.files, title:title};
        this.selectedTestimArray.push(this.selectedTestim);
    }

    selectVolunteer(e, title: string) {
        this.selectedVolunteer = {file:e.target.files, title:title};
        this.selectedVolunteerArray.push(this.selectedVolunteer);
    }

    selectSocial(e, title: string) {
        this.selectedSocial = {file:e.target.files, title:title};
        this.selectedSocialArray.push(this.selectedSocial);
    }

    selectHobby(e, title: string) {
        this.selectedHobby = {file:e.target.files, title:title};
        this.selectedHobbyArray.push(this.selectedHobby);
    }


    public driverLic: Array<Select2OptionData>;

    public departmentsOptions: Options;
    public driverLicOptions: Options;
    public domainOptions: Options;
    public languageOptions: Options;

    personalAchievement: any;
    config: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: '15rem',
        minHeight: '5rem',
        placeholder: 'Enter text here...',
        translate: 'no',
        defaultParagraphSeparator: 'p',
        defaultFontName: 'Arial',
        toolbarHiddenButtons: [
            ['bold']
        ],
        customClasses: [
            {
                name: 'quote',
                class: "quote",
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: "titleText",
                class: "titleText",
                tag: "h1",
            },
        ]
    };

    idealCompany: any;
    idealJob: any;
    idealBenefits: any;

    lastNameFail:boolean;
    firstNameFail:boolean;

    // TODO must be changed with User model but interfce is not working right yet
    userData: any;
    formIsGenerated = false;

    // isStillEmployed: boolean = false;

    // Declare the form
    public form: {
        studies: UserStudies[];
        career: UserCareer[];
        userLanguages: UserLanguages[];
        skills: UserSkills[];
        certification: UserCertification[];
        award: UserCertification[];
        top: UserCertification[];
        testimonial: UserCertification[];
        volunteer: UserCertification[];
        social: UserCertification[];
        hobbies: UserCertification[];
    };

    constructor(private myCareerService: CandidateDataService,
                private selectFields: SelectFieldsTable,
                private router: Router,
                private route: ActivatedRoute,
                private uploadService: UploadFilesService,
                private uploadDTOService: UploadService,
                private locationSelect: SelectLocationTable) {
        // Initialize the template-form component.
        this.form = {
            studies: [],
            career: [],
            userLanguages: [],
            skills: [],
            certification: [],
            award: [],
            top: [],
            testimonial: [],
            volunteer: [],
            social: [],
            hobbies: [],
        };
    }

    // --- Dropdown for country and city
    selectedCountry: String = '--Choose Country--';
    selectedCity: String = '--Choose City--';

    Countries = this.locationSelect.Countries;

    cities: Array<any> = []; //Angular 11

    changeCountry(country: any) { //Angular 11
        this.cities = this.Countries.find((cntry: any) => cntry.name == country.target.value).cities; //Angular 11
    }

    // --- End of dropdown for country and city

    domains = this.selectFields.domains;

    subdomains: Array<any> = [];

    changeDomain(domain: any) {
        this.subdomains = this.domains.find((dmn: any) => dmn.name == domain).subdomains;
    }

    // editorConfig: AngularEditorConfig = {
    //     editable: true,
    //     height: 'auto',
    //     minHeight: '200px',
    //     maxHeight: 'auto',
    //     width: 'auto',
    //     minWidth: '0',
    //     enableToolbar: true,
    //     showToolbar: true,
    //     placeholder: 'Enter text here...',
    //     defaultParagraphSeparator: 'p',
    //     defaultFontName: '',
    //     defaultFontSize: '',
    //     fonts: [
    //         {class: 'arial', name: 'Arial'},
    //         {class: 'times-new-roman', name: 'Times New Roman'},
    //     ],
    //     sanitize: true,
    //     toolbarPosition: 'top',
    //     toolbarHiddenButtons: [
    //         ['insertImage'],
    //         ['fontSize'],
    //         ['insertVideo'],
    //         ['subscript'],
    //         ['superscript'],
    //         ['textColor'],
    //         ['backgroundColor']
    //     ]
    // };

    ngOnInit() {
       this.currentDate.setFullYear(this.currentDate.getFullYear() - 16);
        let domainsArray = [];
        this.domains.forEach(function (value) {
            let domain = value.name;
            domainsArray.push(domain);
        });
        this.domainsArrayValues = domainsArray;

        this.departments = this.selectFields.departments;
        this.languages = this.selectFields.languages;

        this.driverLic = [
            {
                id: 'no',
                text: 'Fara'
            },
            {
                id: 'A',
                text: 'A'
            },
            {
                id: 'B',
                text: 'B'
            },
            {
                id: 'C',
                text: 'C'
            },
            {
                id: 'D',
                text: 'D'
            },
            {
                id: 'E',
                text: 'E'
            },
            {
                id: 'Tr',
                text: 'Tr'
            },
            {
                id: 'Td',
                text: 'Td'
            },
            {
                id: 'Tb',
                text: 'Tb'
            }
        ];

        this.languageOptions = {
            width: '100%',
            multiple: false,
            allowClear: false
        }

        this.departmentsOptions = {
            width: '100%',
            multiple: true,
            allowClear: true,
            theme: 'classic',
        };

        this.driverLicOptions = {
            width: '100%',
            multiple: true,
            allowClear: true
        }

        this.domainOptions = {
            width: '100%',
            multiple: false,
            allowClear: true
        }

        this.myCareerService.getUserData()
            .subscribe(user => {
                this.userData = user;

                if (this.userData.userCountry != null) {
                    this.selectedCountry = this.userData.userCountry;
                }

                if (this.userData.city != null) {
                    this.selectedCity = this.userData.city;
                }

                if (this.selectedCountry != null) {
                    this.cities = this.Countries.find((cntry: any) => cntry.name == this.selectedCountry).cities;
                }

                if (this.userData.userActivitySector != null) {
                    this.selectedDomain = this.userData.userActivitySector;
                }

                if (this.userData.userActivitySubSector != null) {
                    this.selectedSubDomain = this.userData.userActivitySubSector;
                }


                if (this.selectedDomain != null) {
                    this.subdomains = this.domains.find((dmn: any) => dmn.name == this.selectedDomain).subdomains;
                }

                this.formIsGenerated = true;

                this.profilePicturePath = this.userData.profileImagePath;
                
                // if ((this.userData.profileImageId) === "defaultProfileImage.png") {
                //     this.profilePicturePath = "http://" + this.filesBaseHost + "/agri/defaultProfileImage.png";
                // } else {
                //     this.profilePicturePath = "http://" + this.filesBaseHost + "/agri/files/users/" + this.userData.id + "/userProfileImages/" + this.userData.profileImageId;
                // }

                if (this.userData.volunteering != null) {
                    this.form.volunteer = this.userData.volunteering;
                }

                if (this.userData.certification != null) {
                    this.form.certification = this.userData.certification;
                }

                if (this.userData.award != null) {
                    this.form.award = this.userData.award;
                }

                if (this.userData.top != null) {
                    this.form.top = this.userData.top;
                }

                if (this.userData.recommendation != null) {
                    this.form.testimonial = this.userData.recommendation;
                }

                if (this.userData.socialAction != null) {
                    this.form.social = this.userData.socialAction
                }

                if (this.userData.personalAchievement != null) {
                    this.form.hobbies = this.userData.personalAchievement;
                }

                if (this.userData.ability != null) {
                    this.form.skills = this.userData.ability;
                }

                if (this.userData.userExperience != null) {
                    this.form.career = this.userData.userExperience;
                    this.userData.userExperience.forEach((experiance) =>{
                        if(experiance.jobEndDate === null){
                            experiance.isStillEmployed = true;
                        }
                    })
                }

                if (this.userData.foreignLanguage != null) {
                    this.form.userLanguages = this.userData.foreignLanguage;
                }

                if (this.userData.allUserStudies != null) {
                    this.form.studies = this.userData.allUserStudies;
                }

                this.profileImageId = this.userData.profileImageId;
                console.log(this.userData)
                console.log(this.userData.profileImagePath, 'Path')
            }, error => {
            });
    }

    letterCheck(name, value){
        if(name === 'lastName') {
            if(!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(value))){
                console.log(value)
                this.lastNameFail = true;
            }else{
                console.log(value)
                this.lastNameFail = false;
            }
        }
        if(name === 'firstName') {
            if(!(/^[a-zăîșțâA-ZĂÎȘȚÂ\s\-\']*$/.test(value))){
                this.firstNameFail = true;
            }else{
                this.firstNameFail = false;
            }
        }
    }


    onSubmit(editProfile: NgForm) {

        if(this.firstNameFail || this.lastNameFail){
            window.scrollTo({top: 0, behavior: 'smooth'});
            return;
        }

        this.userDTO = {
            volunteer: editProfile.value.volunteering,
            certification: editProfile.value.certification,
            award: editProfile.value.award,
            top: editProfile.value.top,
            testimonial: editProfile.value.testimonial,
            socialAction: editProfile.value.socialAction,
            personalAchievement: editProfile.value.personalAchievement,
            allUserStudies: editProfile.value.allUserStudies,
            ability: editProfile.value.ability,
            userExperience: editProfile.value.userExperience,
            foreignLanguage: editProfile.value.foreignLanguage
        }

        // ----- simple DTO arrays
        let studyValues = [];
        for (let key of Object.keys(this.userDTO.allUserStudies)) {
            let userStudy = this.userDTO.allUserStudies[key];
            studyValues.push(userStudy);
        }

        let abilityValues = [];
        for (let key of Object.keys(this.userDTO.ability)) {
            let ability = this.userDTO.ability[key];
            abilityValues.push(ability);
        }

        let experienceValues = [];
        for (let key of Object.keys(this.userDTO.userExperience)) {
            let experience = this.userDTO.userExperience[key];
            experienceValues.push(experience);
        }

        let languagesValues = []
        for (let key of Object.keys(this.userDTO.foreignLanguage)) {
            let language = this.userDTO.foreignLanguage[key];
            languagesValues.push(language);
        }
        //------- End of simple DTO arrays


        // --- Upload DTO arrays
        let newCertifValues = []; // New array to store certificates from database
        // Loop through array to check if empty entries exist and skip them
        if (this.userData.certification != null ) {
            for (let certif of this.userData.certification) {
                if (certif.title != "") {
                    console.log(certif,'certif')
                    newCertifValues.push(certif);
                }
            }
        }

        let newAwardValues = [];
        if (this.userData.award != null ) {
            for (let award of this.userData.award) {
                if (award.title != "") {
                    newAwardValues.push(award);
                }
            }
        }

        let newTopValues = [];
        if (this.userData.top != null ) {
            for (let top of this.userData.top) {
                if (top.title != "") {
                    newTopValues.push(top);
                }
            }
        }

        let newTestimValues = [];
        if (this.userData.recommendation != null ) {
            for (let testim of this.userData.recommendation) {
                if (testim.title != "") {
                    newTestimValues.push(testim);
                }
            }
        }

        let newVolunteerValues = [];
        if (this.userData.volunteering != null ) {
            for (let volunteer of this.userData.volunteering) {
                if (volunteer.title != "") {
                    newVolunteerValues.push(volunteer);
                }
            }
        }

        let newSocialValues = [];
        if (this.userData.socialAction != null ) {
            for (let socialAction of this.userData.socialAction) {
                if (socialAction.title != "") {
                    newSocialValues.push(socialAction);
                }
            }
        }

        let newHobbyValues = [];
        if (this.userData.personalAchievement != null ) {
            for (let hobby of this.userData.personalAchievement) {
                if (hobby.title != "") {
                    newHobbyValues.push(hobby);
                }
            }
        }
        // --- End of upload DTO arrays
        
        if((editProfile.value.dateOfBirth > this.currentDate.toISOString().split('T')[0]) || editProfile.value.dateOfBirth === null ){
            this.underAge = true;

            this.formResponse = false;
            this.formSent = true;

            window.scrollTo({top: 0, behavior: 'smooth'});
   
            return
        }
        this.userNewData = {
            profileImagePath : this.userData.profileImagePath,
            profileImageId: this.profileImageId,
            firstName: editProfile.value.firstName,
            lastName: editProfile.value.lastName,
            dateOfBirth: editProfile.value.dateOfBirth,
            userCountry: editProfile.value.userCountry,
            city: editProfile.value.userCity,
            telephone: editProfile.value.telephone,
            linkedinProfile: editProfile.value.linkedinProfile,
            facebookProfile: editProfile.value.facebookProfile,
            youtubeProfile: editProfile.value.youtubeProfile,
            twitterProfile: editProfile.value.twitterProfile,
            anotherSocialMediaAccount: editProfile.value.anotherSocialMediaAccount,
            userActivitySector: editProfile.value.userDomain,
            userActivitySubSector: editProfile.value.userSubdomain,
            userDepartment: editProfile.value.userDepartment,
            gender: editProfile.value.gender,
            availabilityOfRelocation: editProfile.value.availabilityOfRelocation,
            workPermissionInEu: editProfile.value.workPermissionInEu,
            civilStatus: editProfile.value.civilStatus,
            allUserStudies: studyValues.length != 0 ? studyValues : null,
            otherCourses: editProfile.value.userOtherCourses,
            foreignLanguage: languagesValues.length != 0 ? languagesValues : null,
            pcKnowledge: editProfile.value.userPcKnowledge,
            driverLicense: editProfile.value.userDriverLicense,
            minimumSalary: editProfile.value.userMinimumSalary,
            interestedInBonusSystem: editProfile.value.interestedInBonusSystem,
            mandatoryMealVoucher: editProfile.value.mandatoryMealVoucher,
            mandatoryHolidayVoucher: editProfile.value.mandatoryHolidayVoucher,
            mandatoryServiceCar: editProfile.value.mandatoryServiceCar,
            // compulsoryLifeInsurance": boolean,
            mandatoryHealthPackage: editProfile.value.mandatoryHealthPackage,
            mandatoryFood: editProfile.value.mandatoryFood,
            mandatoryAccommodation: editProfile.value.mandatoryAccommodation,
            coursesInTheCountry: editProfile.value.coursesInTheCountry,
            coursesAboard: editProfile.value.coursesAboard,
            // “miniInterviewUser”: MiniInterview
            userWorkProgram: editProfile.value.userWorkProgram,
            userWorkSpace: editProfile.value.userWorkSpace,
            idealCompany: editProfile.value.idealCompany,
            idealJob: editProfile.value.idealJob,
            idealBenefits: editProfile.value.idealBenefits,
            userAvailableForTraveling: editProfile.value.userAvailableForTraveling,
            userCommute: editProfile.value.userCommute,
            physicalEffortAvailability: editProfile.value.physicalEffortAvailability,
            weightLiftingAvailability: editProfile.value.weightLiftingAvailability,
            workTemperature: editProfile.value.workTemperature,
            currentJob: editProfile.value.currentJob,
            availableForWork: editProfile.value.availableForWork,
            jobType: editProfile.value.jobType,
            currentExperienceLevel: editProfile.value.currentExperienceLevel,
            desiredLevelOfJob: editProfile.value.desiredLevelOfJob,
            regionOfInterest: editProfile.value.regionOfInterest,
            ability: abilityValues.length != 0 ? abilityValues : null,
            certification: newCertifValues,
            award: newAwardValues,
            top: newTopValues,
            recommendation: newTestimValues,
            volunteering: newVolunteerValues,
            socialAction: newSocialValues,
            personalAchievement: newHobbyValues,
            address: editProfile.value.address,
            userExperience: experienceValues.length != 0 ? experienceValues : null,
            linkVideoCV: editProfile.value.linkVideoCV
        }

        console.log(newTestimValues, "------Testim------")
        console.log(this.userNewData, 'newData')

        if (editProfile.valid) {
            this.myCareerService.updateUserData(this.userNewData).subscribe(res => {
                this.upload();

                // --- Upload DTO files
                for (let certificate of this.selectedCertifArray) {
                    this.uploadDTOService.upload(certificate.file, '/uploadUserFile?userFileType=certification&title=' + certificate.title);
                }

                for (let award of this.selectedAwardArray) {
                    this.uploadDTOService.upload(award.file, '/uploadUserFile?userFileType=award&title=' + award.title);
                }

                for (let top of this.selectedTopArray) {
                    this.uploadDTOService.upload(top.file, '/uploadUserFile?userFileType=top&title=' + top.title);
                }

                for (let testim of this.selectedTestimArray) {
                    this.uploadDTOService.upload(testim.file, '/uploadUserFile?userFileType=recommendation&title=' + testim.title);
                }

                for (let volunteer of this.selectedVolunteerArray) {
                    this.uploadDTOService.upload(volunteer.file, '/uploadUserFile?userFileType=volunteering&title=' + volunteer.title);
                }

                for (let socialAction of this.selectedSocialArray) {
                    this.uploadDTOService.upload(socialAction.file, '/uploadUserFile?userFileType=socialAction&title=' + socialAction.title);
                }

                for (let hobby of this.selectedHobbyArray) {
                    this.uploadDTOService.upload(hobby.file, '/uploadUserFile?userFileType=personalAchievement&title=' + hobby.title);
                }
                // --- End of upload DTO files

                this.formResponse = true;
                this.formSent = true;
                console.log(this.userNewData, this.profileImageId, "Data+img")
                window.scrollTo({top: 0, behavior: 'smooth'});


                setTimeout(() => {
                    this.router.navigate(['/profilul-meu'])
                }, 4000);

            }, error => {
                this.formResponse = false;
                this.formSent = true;

                window.scrollTo({top: 0, behavior: 'smooth'});

            });
        } else {

            this.formResponse = false;
            this.formSent = true;

            window.scrollTo({top: 0, behavior: 'smooth'});

        }

    }


    public upload(): void {
        this.progress = 0;

        if (this.selectedFiles) {
            const file: File | null = this.selectedFiles.item(0);
            this.fileUpload = true;
            
            console.log(this.fileUpload)

            if (file) {
                this.currentFile = file;

                this.uploadService.upload(this.currentFile).subscribe(
                    (event: any) => {
                        if (event instanceof HttpResponse) {
                            this.message = event.body.message;
                            // this.fileInfos = this.uploadService.getFiles();
                        }
                    },
                    (err: any) => {
                        this.progress = 0;
                        if (err.error && err.error.message) {
                            this.message = err.error.message;
                        } else {
                            this.message = 'Could not upload the file!';
                        }

                        this.currentFile = undefined;
                    });
            }
            //this.selectedFiles = undefined;
        }
    }


    public addVolunteer(volunteer?): void {
        this.form.volunteer.push({
            id: Date.now(), // This is for creating unique fields
            name: '',
            link: '',
            title: ''
        });
    }

    // --- Add a group of fields to the form

    public addStudies(): void {
        this.form.studies.push({
            id: Date.now(), // This is for creating unique fields
            userStudies: '',
            studyName: '',
            studyLocation: '',
            studyStartDate: '',
            studyEndDate: '',
            diplomaStudies: '',
        });
    }

    public addUserLanguages(): void {
        this.form.userLanguages.push({
            id: Date.now(),
            language: '',
            level: ''
        });
    }

    public addCareer(experience?): void {
        this.form.career.push({
            id: Date.now(),
            positionHeld: '',
            employer: '',
            country: '',
            town: '',
            jobStartDate: '',
            jobEndDate: '',
            mainResponsibility: '',
            isStillEmployed: false
        });
    }

    public addSkills(): void {
        this.form.skills.push({
            id: Date.now(), // This is for creating unique fields
            abilityName: '',
            abilityDescription: '',
            abilityLevel: ''
        });
    }

    public addCertification(certification?): void {
        this.form.certification.push({
            link: '',
            title: ''
        });

    }

    public addAwards(award?): void {
        this.form.award.push({
            id: Date.now(), // This is for creating unique fields
            name: '',
            link: '',
            title: ''
        });
    }

    public addTop(top?): void {
        this.form.top.push({
            id: Date.now(), // This is for creating unique fields
            name: '',
            link: '',
            title: ''
        });
    }

    public addTestim(): void {
        this.form.testimonial.push({
            id: Date.now(), // This is for creating unique fields
            name: '',
            link: '',
            title: ''
        });
    }

    public addSocial(): void {
        this.form.social.push({
            id: Date.now(), // This is for creating unique fields
            name: '',
            link: '',
            title: ''
        });
    }

    public addHobbies(): void {
        this.form.hobbies.push({
            id: Date.now(), // This is for creating unique fields
            name: '',
            link: '',
            title: ''
        });
    }

    // --- Remove one group of fields from the form
    public removeStudies(index: number): void {
        this.form.studies.splice(index, 1);
    }

    public removeSkills(index: number): void {
        this.form.skills.splice(index, 1);
    }

    public removeCertification(index: number): void {
        this.form.certification.splice(index, 1);

        let newCertifValues = []; // New array to store certificates from database
        // Loop through array to check if empty entries exist and skip them
        if (this.userData.certification != null ) {
            for (let certif of this.userData.certification) {
                if (certif.link != "") {
                    newCertifValues.push(certif);
                }
            }
        }
        if ((index-newCertifValues.length)>= 0) { // index of uploaded files vs backend files
            this.selectedCertifArray.splice((index-newCertifValues.length), 1); // delete from uploaded files array
        }

    }

    public removeTop(index: number): void {
        this.form.top.splice(index, 1);

        let newTopValues = [];
        if (this.userData.top != null ) {
            for (let top of this.userData.top) {
                if (top.link != "") {
                    newTopValues.push(top);
                }
            }
        }

        if ((index-newTopValues.length)>= 0) { // index of uploaded files vs backend files
            this.selectedTopArray.splice((index-newTopValues.length), 1); // delete from uploaded files array
        }
    }

    public removeAwards(index: number): void {
        this.form.award.splice(index, 1);

        let newAwardValues = [];
        if (this.userData.award != null ) {
            for (let award of this.userData.award) {
                if (award.link != "") {
                    newAwardValues.push(award);
                }
            }
        }

        if ((index-newAwardValues.length)>= 0) { // index of uploaded files vs backend files
            this.selectedAwardArray.splice((index-newAwardValues.length), 1); // delete from uploaded files array
        }
    }

    public removeTestim(index: number): void {
        this.form.testimonial.splice(index, 1);

        let newTestimValues = [];
        if (this.userData.recommendation != null ) {
            for (let testim of this.userData.recommendation) {
                if (testim.link != "") {
                    newTestimValues.push(testim);
                }
            }
        }

        if ((index-newTestimValues.length)>= 0) { // index of uploaded files vs backend files
            this.selectedTestimArray.splice((index-newTestimValues.length), 1); // delete from uploaded files array
        }
    }

    public removeVolunteer(index: number): void {
        this.form.volunteer.splice(index, 1);

        let newVolunteerValues = [];
        if (this.userData.volunteering != null ) {
            for (let volunteer of this.userData.volunteering) {
                if (volunteer.link != "") {
                    newVolunteerValues.push(volunteer);
                }
            }
        }

        if ((index-newVolunteerValues.length)>= 0) { // index of uploaded files vs backend files
            this.selectedVolunteerArray.splice((index-newVolunteerValues.length), 1); // delete from uploaded files array
        }
    }

    public removeSocial(index: number): void {
        this.form.social.splice(index, 1);

        let newSocialValues = [];
        if (this.userData.socialAction != null ) {
            for (let socialAction of this.userData.socialAction) {
                if (socialAction.link != "") {
                    newSocialValues.push(socialAction);
                }
            }
        }

        if ((index-newSocialValues.length)>= 0) { // index of uploaded files vs backend files
            this.selectedSocialArray.splice((index-newSocialValues.length), 1); // delete from uploaded files array
        }
    }

    public removeHobbies(index: number): void {
        this.form.hobbies.splice(index, 1);

        let newHobbyValues = [];
        if (this.userData.personalAchievement != null ) {
            for (let hobby of this.userData.personalAchievement) {
                if (hobby.link != "") {
                    newHobbyValues.push(hobby);
                }
            }
        }

        if ((index-newHobbyValues.length)>= 0) { // index of uploaded files vs backend files
            this.selectedHobbyArray.splice((index-newHobbyValues.length), 1); // delete from uploaded files array
        }

    }

    public removeCareer(index: number): void {
        this.form.career.splice(index, 1);
    }

    public removeUserLanguages(index: number): void {
        this.form.userLanguages.splice(index, 1);
    }
}
